import { useHead } from "@unhead/react"
import Navbar from "@/components/Navbar"
import HeroSection from "@/components/HeroSection"
import AffiliateBanner from "@/components/AffiliateBanner"
import FatCalculator from "@/components/FatCalculator"
import EducationSection from "@/components/EducationSection"
import TDEEFatSection from "@/components/TDEEFatSection"
import TDEEvsBMISection from "@/components/TDEEvsBMISection"
import WaterIntakeCalculator from "@/components/WaterIntakeCalculator"
import FAQSection from "@/components/FAQSection"
import CTASection from "@/components/CTASection"
import AffiliateBanner3 from "@/components/AffiliateBanner3"
import Footer from "@/components/Footer"

export default function Home() {
  useHead({
    title: "Fat Intake Calculator | Daily Fat Grams & Requirement Tool",
    meta: [
      {
        name: "description",
        content:
          "Use our fat intake calculator to find exactly how many fat grams per day you need. Expert tool for weight loss, keto, and bodybuilding. Calculate your fat requirements instantly.",
      },
      {
        name: "keywords",
        content:
          "fat intake calculator, daily fat intake calculator, fat requirement calculator, calculate fat grams per day, fat needs calculator, fat intake calculator for bodybuilding, water intake calculator for weight loss",
      },
      { property: "og:title", content: "Fat Intake Calculator | Daily Fat Grams & Requirement Tool" },
      {
        property: "og:description",
        content:
          "Use our fat intake calculator to find exactly how many fat grams per day you need. Expert tool for weight loss, keto, and bodybuilding.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: "Fat Intake Calculator | Daily Fat Grams & Requirement Tool" },
      {
        name: "twitter:description",
        content:
          "Use our fat intake calculator to find exactly how many fat grams per day you need. Expert tool for weight loss, keto, and bodybuilding.",
      },
    ],
    htmlAttrs: { lang: "en" },
  })

  const webPageSchema = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "Fat Intake Calculator | Daily Fat Grams & Requirement Tool",
    "description": "Use our fat intake calculator to find exactly how many fat grams per day you need. Expert tool for weight loss, keto, and bodybuilding. Calculate your fat requirements instantly.",
    "url": "https://fatintakecalculator.com",
    "mainEntity": {
      "@type": "SoftwareApplication",
      "name": "Fat Intake Calculator",
      "applicationCategory": "HealthApplication",
      "operatingSystem": "Web",
      "offers": {
        "@type": "Offer",
        "price": "0",
        "priceCurrency": "USD",
      },
    },
  }

  return (
    <div className="min-h-screen bg-white">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(webPageSchema) }}
      />
      <Navbar />
      <HeroSection />
      <AffiliateBanner />
      <FatCalculator />
      <EducationSection />
      <TDEEFatSection />
      <TDEEvsBMISection />
      <WaterIntakeCalculator />
      <AffiliateBanner3 />
      <CTASection />
      <FAQSection />
      <Footer />
    </div>
  )
}
